import { render, staticRenderFns } from "./matrix.vue?vue&type=template&id=4bf190a1&scoped=true&"
import script from "./matrix.vue?vue&type=script&lang=js&"
export * from "./matrix.vue?vue&type=script&lang=js&"
import style0 from "./matrix.vue?vue&type=style&index=0&id=4bf190a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf190a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf190a1')) {
      api.createRecord('4bf190a1', component.options)
    } else {
      api.reload('4bf190a1', component.options)
    }
    module.hot.accept("./matrix.vue?vue&type=template&id=4bf190a1&scoped=true&", function () {
      api.rerender('4bf190a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/matrix.vue"
export default component.exports